// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@tailwind base;@tailwind components;@tailwind utilities;.van-tabbar .van-tabbar-item{font-size:1rem}", ""]);
// Exports
module.exports = exports;
